import localUrl from '@/axios/localUrl';
import {Loading, Message} from "element-ui";
import request from "@/axios/request";
export const judgeLogin = () => {
  const token = sessionStorage.getItem('token_portalUI');
  const userInfo = sessionStorage.getItem('userInfo_portalUI');
  return !!(token && userInfo);

}
export const goLogin = () => {
  const origin = window.location.origin
  // 线上
  if (process.env.NODE_ENV === 'production') {
    window.location.href = origin + '/service/oauth2/authorize?client_id=gczxPortal&response_type=code&redirect_uri=' +
        localUrl.redirectUrl
  }else {
    window.location.href = 'https://auth-test.gczx.com:8443/service/oauth2/authorize?client_id=localPortal&response_type=code&redirect_uri=' +
        localUrl.redirectUrl
  }
  // window.location.href = 'https://auth-test.gczx.com:8443/service/oauth2/authorize?client_id=gczxPortal&response_type=code&redirect_uri=' + localUrl.redirectUrl
}
export const isDev = () => {
  return process.env.NODE_ENV === 'development';
}

// 根据后端返回结果判断是下载文件，还是展示提示信息
export const exportExcel = (
    url,
    data,
    type = "application/json",
    method = "get",
    headers,
) => {
  const loadingInstance = Loading.service({
    lock: true,
    text: '下载中，请稍后...',
    spinner: "el-icon-loading",
  });
  request({
    url,
    data,
    params: method == "get" ? data : undefined,
    method,
    responseType: 'blob',
    headers: {
      "content-Type": type,
      ...headers
    },
  })
      .then((res) => {
        const contentType = res.headers["content-type"];
        // 如果是json格式，将blob还原为json
        if (contentType.indexOf('application/json') === 0) {
          const reader = new FileReader();
          reader.readAsText(res.data, 'UTF-8');
          reader.onload = function(e) {
            const {message} = JSON.parse(e.target.result);
            app.$message.success(message || '未知错误');
          };
        } else {
          const disposition = res.headers["content-disposition"];
          let fileName = "";
          let name = "";
          let suffix = "";
          if (disposition) {
            fileName = disposition.split("=")[1];
            const [na, suf] = fileName.split("'").length == 1 ? fileName.split(".") : fileName.split("'")[2].split(".")
            name = window.decodeURIComponent(na);
            suffix = suf;
          }
          const data = res.data;
          const url = URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = url;
          link.download = name ? `${name}.${suffix}` : "文件下载";
          link.click();
        }
      })
      .catch((err) => {
        console.log("debug log --> ", err);
      })
      .finally(() => {
        loadingInstance.close();
      });
};
